import * as yup from "yup";

export const updateAssessmentOverviewSchema = yup.object().shape({
  requestedDraftDate: yup.object({
    startDate: yup
      .date()
      .test(
        "is-valid-date",
        "Start date must be a valid date",
        (value) => !isNaN(new Date(value).getTime())
      ),
  }),
  agreedDraftDate: yup.object({
    startDate: yup
      .date()
      .test(
        "is-valid-date",
        "Start date must be a valid date",
        (value) => !isNaN(new Date(value).getTime())
      ),
  }),
  assessmentDraftDate: yup.object({
    startDate: yup
      .date()
      .test(
        "is-valid-date",
        "Start date must be a valid date",
        (value) => !isNaN(new Date(value).getTime())
      ),
  }),
});
